<template>
    <div class="help-center bg-white">
      <CContainer>
        <!-- Header -->
        <CRow class="header-row mb-3 position-relative">
          <CCol class="col-auto">
            <CButton class="back-button" @click="$router.go(-1)">
              ←
            </CButton>
          </CCol>
          <CCol class="d-flex justify-content-center position-absolute start-50 translate-middle-x">
            <h3 class="section-title m-0">Help Center</h3>
          </CCol>
        </CRow>
        
        <!-- Subtitle -->
        <br />
        <h5 class="font-weight-bold mt-5">How can we help?</h5>
        <p class="text-muted">A fully functional search system</p>
        
        <!-- Search Bar -->
        <div class="search-bar mb-3">
          <CInput placeholder="Search..." class="w-100" />
        </div>
        
        <!-- FAQ Section -->
<div v-for="(item, index) in faqItems" :key="index" :title="item.question">
        <ToggleCard :title="item.question" class="font-inter">
          {{ item.answer }}
        </ToggleCard>
      </div>
    
        <!-- <CAccordion>
          <CAccordionItem v-for="(item, index) in faqItems" :key="index" :title="item.question">
            <CCard>
              <p class="text-muted">{{ item.answer }}</p>
            </CCard>
            
          </CAccordionItem>
        </CAccordion> -->
      </CContainer>
    </div>
  </template>
  
  <script>
  import ToggleCard from '../components/Toggle.vue';
  export default {
    components: {
        ToggleCard
    },
    data() {
      return {
        faqItems: [
          { question: "What is [App Name]?", answer: "[App Name] is a smart video analysis app..." },
          { question: "How do I get started?", answer: "To get started, simply sign up and follow the tutorial..." },
          { question: "Can I use the app for free?", answer: "Yes, we offer a free version with limited features..." },
          { question: "How does video analysis work?", answer: "Our app analyzes your videos using AI to provide insights..." },
          { question: "What platforms are supported?", answer: "We support iOS, Android, and web-based platforms..." },
          { question: "How do I manage my subscription?", answer: "Go to your account settings to manage your subscription..." },
          { question: "Is my data secure?", answer: "We use encryption and security protocols to protect your data..." }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .help-center {
    padding: 20px;
  }
  
  .back-button {
    font-size: 18px;
  }
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
  }
  
  .search-bar input {
    border-radius: 8px;
    padding: 10px;
    border: 1px solid #ccc;
  }
  @import url('https://fonts.cdnfonts.com/css/general-sans');
  body {
      top: 0 !important;
      font-family: 'General Sans', sans-serif;
  }
  </style>